import './document-button.scss';

import { NewConvergeButton } from '../../../presentation';

interface ISubmissionDocumentLink {
  submissionDocumentLink: string;
}
export const DocumentButton = ({
  submissionDocumentLink,
}: ISubmissionDocumentLink) => {
  return (
    <NewConvergeButton
      label={'View Documents'}
      href={submissionDocumentLink}
      target="_blank"
    />
  );
};
